var ProcessSeriesDataPie = function (processedData) {

  var series = [];
  for (var l = 0; l < Object.keys(processedData).length; l++) {
      // Push name and y for series
      series.push({
          "name": processedData[l].legendKey,
          "y": processedData[l].seriesKey
      });
  }
  return series;
}

exports.ProcessSeriesDataPie=ProcessSeriesDataPie;



//////////////////
// WEBPACK FOOTER
// ./src/modules/ProcessSeriesDataPie/ProcessSeriesDataPie.js
// module id = 11
// module chunks = 0